import { toRestErrorResponseData } from 'providers/tanstack-query-rest/errors'

type AgentApiError = {
  code: string
  message: string
}

export const VALIDATION_FAILED: AgentApiError['code'] = 'VALIDATION_FAILED'

const isAgentApiError = (data: unknown): data is AgentApiError =>
  typeof data === 'object' &&
  data !== null &&
  'code' in data &&
  typeof data.code === 'string' &&
  'message' in data &&
  typeof data.message === 'string'

const toAgentApiError = (error: unknown): AgentApiError | undefined => {
  const data: unknown = toRestErrorResponseData(error)

  return isAgentApiError(data) ? data : undefined
}

export const toAgentErrorMessage = (responseData: unknown): string | undefined =>
  isAgentApiError(responseData) ? responseData.message : undefined

export const toRejectedUrlMessage = (error: unknown): string | undefined => {
  const apiError: AgentApiError | undefined = toAgentApiError(error)

  return apiError?.code === VALIDATION_FAILED ? apiError.message : undefined
}
